module.exports = __webpack_public_path__ + "img/solution-1.4f39e01c.jpg";